import { Instituciones } from "../Instituciones/Instituciones";
import { useHome } from "../../../hooks/useHome";
import { Fragment, useEffect } from "react";
import { pathImages } from "../../../routes/endpoints";
import { MENU } from "../../../constants";
import { alignDinamicClass, dinamicResponsiveClass, getMenuControl, getNavControl, handleOpenPage } from "../../../helpers/home/helper";
import './navegadores.css';

export const Navegadores = () => {
    const {
        contenido,
        menu,
        subMenu,
        menuOpen,
        submenuOpen,
        handleMenuClick,
        handleSubmenuClick,
        getContenido,
    } = useHome();


    useEffect(() => {
        getContenido();

    }, []);

    const chunkSize = 3;

    const dividedData = [];

    for (let i = 0; i < contenido.length; i += chunkSize) {
        const chunk = contenido.slice(i, i + chunkSize);
        dividedData.push(chunk);
    };

    return (
        <>
            <div className="container-fluid py-3 d-flex justify-content-center" role="navigation" aria-label="menu principal">

                <div className="row wrapper-navegadores ">

                    {dividedData.map((group, index) => (
                        <div className="row row-cols-3 justify-content-center d-flex" key={index}>
                            {group.map(({ id, imagen, titulo, pdf, url }, i) => (


                                <div className="col col-navegadores" key={id} >
                                    {url || pdf ?
                                        <a className="bg-gris" href="#" onClick={(e) => { handleOpenPage(e, url, pdf) }} role="link" aria-label={titulo}>
                                            <img src={`${pathImages}${imagen}`} className="iconos-navegadores" alt="" />
                                            <span className="separador"></span>
                                            <p className="titulo-navegadores">
                                                {titulo}
                                            </p>
                                        </a>
                                        :
                                        <a
                                            className="bg-gris"
                                            data-bs-toggle="collapse"
                                            // href={`#nav${getNavControl(i)}`}
                                            role="button"
                                            aria-label={titulo}
                                            // aria-expanded={menuOpen === id}
                                            // aria-controls={`nav${getNavControl(i)}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleMenuClick(id);
                                            }}>
                                            <img src={`${pathImages}${imagen}`} className="iconos-navegadores" alt="" />
                                            <span className="separador"></span>
                                            <p className="titulo-navegadores">
                                                {titulo}
                                            </p>
                                        </a>
                                    }

                                    <div>

                                        {menu.length ?
                                            <div className={`collapse ${menuOpen === id ? "show" : ""}`} id={`nav${getNavControl(i)}`}>
                                                <div className={`card card-body ${alignDinamicClass(i + 1, MENU)} ${dinamicResponsiveClass(i)}`}>

                                                    <div className="col-md-12 d-flex flex-wrap">

                                                        {menu.map(({ id, imagen, titulo, hasSubmenu, pdf, url }, i) => (
                                                            <div key={id} className="d-flex">
                                                                {url || pdf ?
                                                                    <a className="sub-menu" href="#" onClick={(e) => { handleOpenPage(e, url, pdf) }} role="link" aria-label={titulo}>
                                                                        <img src={`${pathImages}${imagen}`} alt="" className="ico-submenu" />
                                                                        <p className="texto-submenu">{titulo}</p>
                                                                    </a>
                                                                    :
                                                                    <a
                                                                        className="sub-menu"
                                                                        data-bs-toggle="collapse"
                                                                        // href={`#${getMenuControl(titulo)}`}
                                                                        role="button"
                                                                        aria-label={titulo}
                                                                        // aria-expanded={submenuOpen === id}
                                                                        // aria-controls={getMenuControl(titulo)}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleSubmenuClick(id);
                                                                        }}>
                                                                        <img src={`${pathImages}${imagen}`} alt="" className="ico-submenu" />
                                                                        <p className="texto-submenu">{titulo}</p>
                                                                        {!hasSubmenu ?
                                                                            <></>
                                                                            :
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                                                                                className="bi bi-chevron-down" viewBox="0 0 16 16">
                                                                                <path fillRule="evenodd"
                                                                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                                                            </svg>
                                                                        }
                                                                    </a>
                                                                }
                                                                {!hasSubmenu ?
                                                                    null
                                                                    :
                                                                    <div className={`collapse ${submenuOpen === id ? "show" : ""}`} id={getMenuControl(titulo)}>
                                                                        <div className={`card card-body2`}>
                                                                            {subMenu?.map(({ id, texto, url, pdf }) => (
                                                                                <a
                                                                                    key={id}
                                                                                    className="nav-list-menu"
                                                                                    target="_blank"
                                                                                    onClick={(e) => handleOpenPage(e, url, pdf)}>
                                                                                    {texto}
                                                                                </a>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        )
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <></>
                                        }



                                    </div>




                                </div>



                            ))}




                        </div>

                    ))}



                </div>
            </div>

            {/* */}
            <Instituciones />
        </>
    );
};
